package ui.widget

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Chevron_down
import org.jetbrains.compose.resources.StringResource
import org.ssoft.common.type.Mask
import tools.EFieldRegularInt
import tools.rememberString


@Composable
fun <T : Mask> MaskTypePicker(
    items: List<T>,
    field: EFieldRegularInt,
    icon: (T) -> Long,
    label: (T) -> StringResource,
    onItemSelected: (T) -> Unit = {}
) {
    var isMenuExpanded by remember {
        mutableStateOf(false)
    }
    val animation by animateFloatAsState(
        animationSpec = tween(200),
        targetValue = if (isMenuExpanded) 0F
        else -90F
    )

    ElevatedCard(
        onClick = { isMenuExpanded = !isMenuExpanded },
        colors = CardDefaults.elevatedCardColors(
            containerColor = MaterialTheme.colorScheme.surfaceContainerHigh
        )
    ) {

        Row(Modifier.fillMaxWidth().padding(16.dp)) {
            with(Mask[field.state, items] as T) {
                LazyIcon(icon(this), Modifier.size(24.dp))
                Space(16.dp)
                Text(
                    text = label(this).rememberString(),
                    modifier = Modifier.weight(1F)
                        .align(Alignment.CenterVertically)
                )
                Icon(
                    imageVector = Svg.Chevron_down,
                    contentDescription = null,
                    modifier = Modifier
                        .align(Alignment.CenterVertically)
                        .rotate(animation)
                )
            }
        }
        DropdownMenu(
            modifier = Modifier.width(320.dp),
            expanded = isMenuExpanded,
            onDismissRequest = { isMenuExpanded = false }) {
            items.forEach {
                DropdownMenuItem(
                    text = {
                        Row {
                            LazyIcon(icon(it), Modifier.size(24.dp))
                            Space(16.dp)
                            Text(
                                text = label(it).rememberString(),
                                modifier = Modifier.weight(1F)
                                    .align(Alignment.CenterVertically)
                            )
                        }
                    },
                    onClick = {
                        field.set(it.mask)
                        isMenuExpanded = false
                        onItemSelected(it)
                    }
                )
            }
        }
    }
}